import { applicationModulesReducer } from './application-modules/application-modules.reducer';
import { attributesReducer } from './attributes/attributes.reducer';
import { buildingIndicatorsReducer } from './building-indicators/building-indicators.reducer';
import { buildingsAccessesReducer } from './buildings-accesses/buildings-accesses.reducer';
import { buildingsReducer } from './buildings/buildings.reducer';
import { businessIndicatorsReducer } from './business-indicators/business-indicators.reducer';
import { categoriesReducer } from './categories/categories.reducer';
import { contactsReducer } from './contacts/contacts.reducer';
import { dashboardsReducer } from './dashboards/dashboards.reducer';
import { deliveryPointReducer } from './delivery-points/delivery-points.reducer';
import { initialState, type State } from './entities.state';
import { favoriteActivitiesReducer } from './favorite-activities/favorite-activities.reducer';
import { metersReducer } from './meters/meters.reducer';
import { profilesReducer } from './profiles/profiles.reducer';
import { projectsReducer } from './projects/projects.reducer';
import { repartitionCategoryReducer } from './repartition-categories/repartition-categories.reducer';
import { rolesReducer } from './roles/roles.reducer';
import { sensorsReducer } from './sensors/sensors.reducer';
import { systemsReducer } from './systems/systems.reducer';
import { tailoredWidgetsReducer } from './tailored-widgets/tailored-widgets.reducer';
import { timeseriesTagReducer } from './timeseries-tag/timeseries-tag.reducer';
import { unitGroupsReducer } from './unit-groups/unit-groups.reducer';
import { unitsReducer } from './units/units.reducer';
import { widgetTemplatesReducer } from './widget-templates/widget-templates.reducer';

export function entitiesReducer(state: State = initialState, action: any): State {
    return {
        applicationModules: applicationModulesReducer(state.applicationModules, action),
        attributes: attributesReducer(state.attributes, action),
        buildings: buildingsReducer(state.buildings, action),
        buildingsAccesses: buildingsAccessesReducer(state.buildingsAccesses, action),
        buildingIndicators: buildingIndicatorsReducer(state.buildingIndicators, action),
        businessIndicators: businessIndicatorsReducer(state.businessIndicators, action),
        categories: categoriesReducer(state.categories, action),
        contacts: contactsReducer(state.contacts, action),
        deliveryPoints: deliveryPointReducer(state.deliveryPoints, action),
        dashboards: dashboardsReducer(state.dashboards, action),
        meters: metersReducer(state.meters, action),
        projects: projectsReducer(state.projects, action),
        profiles: profilesReducer(state.profiles, action),
        repartitionCategories: repartitionCategoryReducer(state.repartitionCategories, action),
        roles: rolesReducer(state.roles, action),
        sensors: sensorsReducer(state.sensors, action),
        systems: systemsReducer(state.systems, action),
        units: unitsReducer(state.units, action),
        unitGroups: unitGroupsReducer(state.unitGroups, action),
        widgetTemplates: widgetTemplatesReducer(state.widgetTemplates, action),
        tailoredWidgets: tailoredWidgetsReducer(state.tailoredWidgets, action),
        timeseriesTags: timeseriesTagReducer(state.timeseriesTags, action),
        favoriteActivities: favoriteActivitiesReducer(state.favoriteActivities, action)
    };
}
